import angular from 'angular';
import creditCards from './creditCards';

export default angular
  .module('components.creditCards', [])
  .component('creditCards', creditCards).name;
